export type OptionLabel = string | ((option: any) => string) | undefined;

/**
 * Lower-cases and strips accents so that "elec" matches "Électrique".
 */
export function normalizeSearchText(value: unknown): string {
  return String(value ?? "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .trim();
}

/**
 * Resolves the text displayed for an option, following q-select's `option-label` rules:
 * a key of the option object (default "label"), a function, or the option itself for primitives.
 */
export function getOptionLabel(option: any, optionLabel: OptionLabel = "label"): string {
  if (option === null || option === undefined) {
    return "";
  }
  if (typeof option !== "object") {
    return String(option);
  }
  if (typeof optionLabel === "function") {
    return String(optionLabel(option) ?? "");
  }
  return String(option[optionLabel] ?? "");
}

/**
 * Keeps the options whose label contains the searched text (case and accent insensitive).
 */
export function filterOptions(options: any[] | undefined, search: string, optionLabel?: OptionLabel): any[] {
  const list = Array.isArray(options) ? options : [];
  const needle = normalizeSearchText(search);
  if (!needle) {
    return list;
  }
  return list.filter((option) => normalizeSearchText(getOptionLabel(option, optionLabel)).includes(needle));
}
